import { useTagStyles } from '@chakra-ui/react-v2';
import { forwardRef } from '@chakra-ui/system';
import { cx } from '@chakra-ui/utils';

import { TagAction, type TagActionProps } from './TagAction';

export const TagLeftAction = forwardRef<TagActionProps, 'button'>(
  ({ className, ...restProps }, ref) => {
    const styles = useTagStyles();

    return (
      <TagAction
        className={cx('tag__left-action', className)}
        sx={styles.leftAction}
        {...restProps}
        ref={ref}
      />
    );
  },
);
